import React from 'react';
import { Minus, Plus } from 'lucide-react';

export const inr = (n) => '₹' + Math.round(n || 0).toLocaleString('en-IN');

export const CalcLabel = ({ children }) => (
  <label className="block text-[10px] uppercase tracking-[0.2em] font-bold text-[#1A3626]/60 mb-1.5">{children}</label>
);

export const CalcInput = (props) => (
  <input
    {...props}
    className={`w-full bg-white border border-[#E5DCCF] px-3 py-2.5 text-sm text-[#0A1710] focus:outline-none focus:border-[#C6A87C] transition-colors ${props.className || ''}`}
  />
);

export const Stepper = ({ value, onChange, min = 0, max = 9999, step = 1, testId }) => (
  <div className="inline-flex items-center border border-[#E5DCCF] bg-white" data-testid={testId}>
    <button
      type="button"
      onClick={() => onChange(Math.max(min, (value || 0) - step))}
      className="w-9 h-9 flex items-center justify-center text-[#1A3626] hover:bg-[#F3EFEB] transition-colors"
      data-testid={testId ? `${testId}-minus` : undefined}
    >
      <Minus className="w-3.5 h-3.5" />
    </button>
    <span className="w-12 text-center text-sm font-medium text-[#0A1710] tabular-nums">{value || 0}</span>
    <button
      type="button"
      onClick={() => onChange(Math.min(max, (value || 0) + step))}
      className="w-9 h-9 flex items-center justify-center text-[#1A3626] hover:bg-[#F3EFEB] transition-colors"
      data-testid={testId ? `${testId}-plus` : undefined}
    >
      <Plus className="w-3.5 h-3.5" />
    </button>
  </div>
);

export const OptionCard = ({ selected, onClick, children, testId, disabled }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    data-testid={testId}
    className={`w-full text-left border p-4 sm:p-5 transition-all ${selected ? 'border-[#C6A87C] bg-[#C6A87C]/10 ring-1 ring-[#C6A87C]' : 'border-[#E5DCCF] bg-white hover:border-[#C6A87C]/60'} ${disabled ? 'opacity-40 cursor-not-allowed' : ''}`}
  >
    {children}
  </button>
);

export const StatusBadge = ({ status }) => {
  const map = {
    included: 'bg-[#1A3626] text-white',
    mandatory: 'bg-[#C6A87C] text-[#0A1710]',
    optional: 'bg-[#F3EFEB] text-[#1A3626]',
    additional: 'bg-[#F3EFEB] text-[#1A3626]',
    not_available: 'bg-red-50 text-red-600'
  };
  const label = { included: 'Included', mandatory: 'Mandatory', optional: 'Optional', additional: 'Additional', not_available: 'Not available' };
  return <span className={`text-[9px] uppercase tracking-[0.15em] font-bold px-2 py-0.5 ${map[status] || map.optional}`}>{label[status] || status}</span>;
};
